export const styles = theme => ({
  root: {
    height: 20,
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 'bold',
    fontSize: theme.constants.fontSizes.small,
  },
});
